import { axiosBaseQuery } from '@client';
import { createApi } from '@reduxjs/toolkit/query/react';
import { RefData } from '@state/types';

export const portSimulationConfigurationApi = createApi({
  reducerPath: 'portSimulationConfigurationApi',
  baseQuery: axiosBaseQuery({
    baseUrl: '/secured/port-simulation-configuration'
  }),
  endpoints: (build) => ({
    searchPortSimulationConfigurationVessels: build.query<
      RefData[],
      { name: string }
    >({
      query: ({ name: text }) => ({
        url: `/filter-vessels`,
        method: 'GET',
        params: { text }
      })
    })
  })
});

export const { useLazySearchPortSimulationConfigurationVesselsQuery } =
  portSimulationConfigurationApi;
